export const getFormattedTime = (date: any) => {
    let convertedDate = new Date(date);
    let hours = convertedDate.getHours();
    let minutes = convertedDate.getMinutes();
    let meridiem = "AM";
    let convertedHours: string | number = hours;
    let convertedMinutes: string | number = minutes;

    if (convertedHours >= 12) {
        convertedHours = hours - 12;
        meridiem = "PM";
    }
    if (convertedHours == 0) {
        convertedHours = 12;
    }
    convertedMinutes = convertedMinutes < 10 ? "0" + convertedMinutes : convertedMinutes;

    convertedHours = convertedHours < 10 ? "0" + convertedHours : convertedHours;

    let formattedTime = convertedHours + ":" + convertedMinutes;
    formattedTime += " " + meridiem;
    return formattedTime;
};
